/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


wp.blocks.registerBlockStyle( 'core/paragraph', {
    name: 'gtue-news-content-body',
    label: 'Rote Underscores am Zeilenanfang'
} );